export enum StrollrEventType {
  COMMON_TESTCASE_RUN_COMPLETED = 'TestCase run completed',
  COMMON_TESTCASE_RUN_FAILED = 'TestCase run failed',
  COMMON_SAMPLE_PROJECT_CLICK = 'Sample Project clicked',
  COMMON_CREATE_PROJECT_CLICK = 'Create Project clicked',

  WEB_SAMPLE_PROJECT_CLICK = 'Web Sample Project clicked',
  WEB_CREATE_PROJECT_CLICK = 'Web Create Project clicked',
  WEB_SHOW_INSTALL_CHROME_EXT_FS = 'Show Install Chrome Extension Full Screen',
  WEB_CHROME_EXT_INSTALLED = 'Chrome Extension Installed',
  WEB_SHOW_INSTALL_CHROME_EXT_POP_UP = 'Show Install Chrome Extension Popup',
  WEB_BROWSER_RECORDER_STOPPED = 'Browser Recorder stopped',
  WEB_BROWSER_RECORDER_STARTED = 'Browser Recorder started',

  MOBILE_NATIVE_SAMPLE_PROJECT_CLICK = 'Mobile Native Sample Project clicked',
  MOBILE_NATIVE_CREATE_PROJECT_CLICK = 'Mobile Native Create Project clicked',
  SHOW_NEW_UI_ONBOARDING_POPUP = 'Force new UI feature enabled',

  SHOW_TESTCASE_TOOLTIP = 'Show Testcase Tooltip',
}
